module.exports = __webpack_public_path__ + "static/media/threeGreyDots.3db23d7d.svg";